export const LIST_ORDER_PLANNING = 'LIST_ORDER_PLANNING';
export const DELETE_ORDER_PLANNING = 'DELETE_ORDER_PLANNING';
export const STORE_ORDER_PLANNING = 'STORE_ORDER_PLANNING';
export const SAVE_ORDER_PLANNING = 'SAVE_ORDER_PLANNING';
export const AUTOMATE_PURCHASE_ORDER = 'AUTOMATE_PURCHASE_ORDER';
export const REMOVE_PURCHASE_ORDER = 'REMOVE_PURCHASE_ORDER';
export const REFRESH_NEW_PURCHASE_ORDER = 'REFRESH_NEW_PURCHASE_ORDER';

export const LIST_ALL_SHIPPED_FTL = 'LIST_ALL_SHIPPED_FTL';
export const STORE_ALL_SHIPPED_FTL = 'STORE_ALL_SHIPPED_FTL';